export default {
  drawerWidth: 240,
  globalDefaultRowsPerPage: 10,
  globalrowsPerPageOptions: [10, 50, { label: 'Tous', value: -1 }],
  tokenRefreshTime: 9 * 60 * 1000, // 9 minutes in millisecondes
};
